import { Route } from '@angular/router';

export const userRoutes: Route[] = [
  /* { path: '', pathMatch: 'full', component: InsertYourComponentHere } */
];
